module.exports = __webpack_public_path__ + "img/3D.629622e3.svg";